import { FC } from 'react';

const PrivacyPolicyNotice: FC = () => {
    return (
        <span className={'tw-text-sm'}>
            I agree to receive additional communication from TouchBistro like guides, tips, best practices and industry
            events for restaurants. You can withdraw your consent at any time.
        </span>
    );
};

export default PrivacyPolicyNotice;
